import { useCallback } from "react";
import { UserFilesService } from "../../services/userFiles";

export const useUploadFile = (
  type: 1 | 2 | 3 | 4 | 5 | 6,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const upload = useCallback(
    async (options: any) => {
      const { onSuccess, file, onError } = options;

      try {
        setIsLoading(true);

        const formData = new FormData();

        formData.append("file", file);

        const res = await UserFilesService.upload(type, formData);

        setIsLoading(false);

        onSuccess(res.id);

        return true;
      } catch (e: any) {
        onError(e.response.data.title);

        setIsLoading(false);

        return false;
      }
    },
    [setIsLoading, type],
  );

  return { upload };
};
